<script lang="ts" setup>
import { modals } from '../../../composables/useModal';
import { useLocale } from '../../../composables/useLocale';
import Modal from '../../Modal.vue';

const { t } = useLocale();

const emit = defineEmits(['delete', 'cancel']);
</script>
<template>
  <Modal
    :name="modals.CONFIRM_DELETE_USER_QR_CODE"
    :title="t('lcp.confirm_qr_code_removal')"
    :show-close-btn="true"
    action-color="error"
    :action-label="t('lcp.remove_qr_code')"
    :action="() => emit('delete')"
    :cancel-action-label="t('lcp.back')"
    :cancel-action="() => emit('cancel')"
  >
    <p>
      {{ t('lcp.confirm_qr_code_removal_message') }}
    </p>
  </Modal>
</template>
